import { render, staticRenderFns } from "./WaysReport.vue?vue&type=template&id=a20c2e9c"
import script from "./WaysReport.vue?vue&type=script&lang=js"
export * from "./WaysReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports